(function bundleSelectorInit() {
  const root = document.querySelector('[data-bundle-selector]');
  if (!root) return;

  const cards = Array.from(root.querySelectorAll('[data-bundle-card]'));
  const ctaBtn = root.querySelector('[data-bundle-cta]');
  const errorEl = root.querySelector('[data-bundle-error]');
  const matchBanner = root.querySelector('[data-bundle-match]');
  const matchTitle = root.querySelector('[data-bundle-match-title]');
  const matchBody = root.querySelector('[data-bundle-match-body]');
  const insideLink = root.querySelector('[data-bundle-inside]');

  if (!cards.length || !ctaBtn) return;

  const urlSelection = new URLSearchParams(window.location.search).get('bundle');
  const defaultKey = urlSelection || root.dataset.defaultKey || cards[0]?.dataset.bundleKey;
  let selectedIndex = Math.max(
    0,
    cards.findIndex((card) => card.dataset.bundleKey === defaultKey)
  );

  if (!cards[selectedIndex]?.dataset.url) {
    const firstConfiguredIndex = cards.findIndex((card) => card.dataset.url);
    if (firstConfiguredIndex >= 0) {
      selectedIndex = firstConfiguredIndex;
    }
  }

  function getSelectedCard() {
    return cards[selectedIndex] || null;
  }

  function showError(message) {
    if (!errorEl) return;

    if (message) {
      errorEl.hidden = false;
      errorEl.textContent = message;
      return;
    }

    errorEl.hidden = true;
    errorEl.textContent = '';
  }

  function updateCTA() {
    const selected = getSelectedCard();
    const price = selected?.dataset.price || '';
    const label = selected?.dataset.ctaLabel || 'View Bundle';
    const url = selected?.dataset.url || '';
    const hasUrl = Boolean(url);

    ctaBtn.textContent = hasUrl
      ? `${label}${price ? ` — ${price}` : ''}`
      : 'Select a configured bundle product';
    ctaBtn.disabled = !hasUrl;
    if (insideLink) {
      insideLink.hidden = !hasUrl;
      insideLink.href = url || '#';
    }
  }

  function updateMatchBanner(titleText, bodyText) {
    if (!matchBanner) return;

    if (!titleText && !bodyText) {
      matchBanner.hidden = true;
      return;
    }

    if (matchTitle) matchTitle.textContent = titleText || 'Recommended protocol selected';
    if (matchBody) matchBody.textContent = bodyText || 'We preselected the best match from your quiz.';
    matchBanner.hidden = false;
  }

  function announceSelection() {
    const selected = getSelectedCard();

    document.dispatchEvent(new CustomEvent('bundle:changed', {
      bubbles: true,
      detail: {
        variantId: selected?.dataset.variantId || null,
        price: selected?.dataset.price || '—',
        name: selected?.dataset.name || 'Your Protocol',
        url: selected?.dataset.url || '',
        ctaLabel: selected?.dataset.ctaLabel || 'View Bundle',
      },
    }));
  }

  function selectCard(index, options = {}) {
    selectedIndex = Math.max(0, Math.min(index, cards.length - 1));

    cards.forEach((card, cardIndex) => {
      const active = cardIndex === selectedIndex;
      card.classList.toggle('is-selected', active);
      card.setAttribute('aria-checked', String(active));
    });

    updateCTA();
    announceSelection();

    if (options.matchTitle || options.matchBody) {
      updateMatchBanner(options.matchTitle, options.matchBody);
    } else {
      updateMatchBanner(null, null);
    }
  }

  // CRO #20: the tier button adds the protocol to the cart and opens the drawer (no hop to the product page).
  // Falls back to the product page if the variant is unavailable or the add fails.
  async function handleCTA() {
    const selected = getSelectedCard();
    const url = selected?.dataset.url || '';
    const variantId = Number(selected?.dataset.variantId || 0);

    if (!url && !variantId) {
      showError('Select your bundle products in this section before sending shoppers to the homepage bundle pages.');
      return;
    }

    showError(null);
    if (!variantId) {
      window.location.href = url;
      return;
    }

    const original = ctaBtn.textContent;
    ctaBtn.disabled = true;
    ctaBtn.textContent = 'Adding…';
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
      });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      try { sessionStorage.setItem('andros_has_cart', '1'); } catch (e) { /* storage off */ }
      try { window.Shopify?.analytics?.publish?.('andros_home_tier_atc', { variantId }); } catch (e) { /* */ }
      document.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
    } catch (error) {
      console.error('[bundle-selector] Add error:', error);
      if (url) window.location.href = url;
      else showError('Something went wrong. Please try again.');
    } finally {
      ctaBtn.disabled = false;
      ctaBtn.textContent = original;
    }
  }

  cards.forEach((card, index) => {
    card.addEventListener('click', (event) => {
      const clickedCardAction = Boolean(event.target.closest('[data-bundle-card-action]'));

      showError(null);
      selectCard(index);

      if (clickedCardAction) {
        handleCTA();
      }
    });
  });

  ctaBtn.addEventListener('click', handleCTA);

  document.addEventListener('protocol:select', (event) => {
    const targetKey = event.detail?.key;
    if (!targetKey) return;

    const nextIndex = cards.findIndex((card) => card.dataset.bundleKey === targetKey);
    if (nextIndex === -1) return;

    selectCard(nextIndex, {
      matchTitle: event.detail?.title,
      matchBody: event.detail?.body,
    });
  });

  selectCard(selectedIndex);
})();
